import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8b764dae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8b764dae&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b764dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b764dae')) {
      api.createRecord('8b764dae', component.options)
    } else {
      api.reload('8b764dae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8b764dae&scoped=true", function () {
      api.rerender('8b764dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/openAI/index.vue"
export default component.exports